module.exports = __webpack_public_path__ + "media/reskin-images/img--events-1198912d.png";